import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';

import { Location } from '@angular/common';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { InstallationBobstAttendeesPluginService } from './bobst-attendees.service';
import { UntypedFormControl, UntypedFormGroup, UntypedFormBuilder, UntypedFormArray, Validators } from '@angular/forms';
import { ConfirmComponent } from '../../../modal/confirm.component';
import * as _ from 'lodash';
import { maxPhoneLengthValidator } from '../../../utils/maxPhoneLength.directive';
import { InstallationCustomerAttendeesMenuComponent } from '../../../menus';
import { ModalComponent } from '../../../modal/modal.component';
import { EmailValidator } from '../../../utils';
import { ContactsModalComponent } from '../../../shared/components';
import { LoadSpinnerService } from '../../../shared/services';
import { BaseInstallationEditPageComponent } from '../base-installation/edit-view.component';
import { Subscription } from 'rxjs';
import { InstallationBobstContactPluginService } from '../bobstcontact/bobst-contact.service';

@Component({
    selector: 'installation-bobst-attendees-edit',
    templateUrl: './bobst-attendees-edit.component.html',
    standalone: false
})
export class InstallationBobstAttendeesEditPageComponent
  extends BaseInstallationEditPageComponent
  implements OnInit, OnDestroy
{
  inspectionId: string;
  pointId: string;
  pluginId: string;
  plugin: any;
  editForm: UntypedFormGroup;

  public processing = false;
  public menuComponent = InstallationCustomerAttendeesMenuComponent;
  private sub = new Subscription();
  private contactToRemove: number;
  currentItem: UntypedFormGroup;

  @ViewChild('attendeeDeleteConfirm', { static: true }) attendeeDeleteConfirm: ConfirmComponent;
  @ViewChild('importCustomersModal') importCustomersModal: ModalComponent;
  @ViewChild('functionModal', { static: true }) functionModal: ModalComponent;
  constructor(
    protected activatedRoute: ActivatedRoute,
    protected router: Router,
    location: Location,
    protected cdRef: ChangeDetectorRef,
    protected pluginService: InstallationBobstAttendeesPluginService,
    private bobstContactPluginService: InstallationBobstContactPluginService,
    protected loader: LoadSpinnerService,
    protected fb: UntypedFormBuilder
  ) {
    super(location, pluginService, activatedRoute, router);
  }

  get formData() {
    return <UntypedFormArray>this.editForm.controls['attendees'];
  }

  ngOnInit() {
    this.sub.add(
      this.initRoute().subscribe(() => {
        this.initData();
      })
    );
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  initData() {
    this.service.getPlugin(this.inspectionId, this.pluginId).subscribe((data) => {
      this.plugin = data;
      this.initForm();
      this.cdRef.detectChanges();
    });
  }

  initForm() {
    this.editForm = this.fb.group({
      attendees: this.fb.array([])
    });

    const control = <UntypedFormArray>this.editForm.controls['attendees'];
    _.forEach(this.plugin.config.Attendees, (el) => {
      control.push(this.initCustomer(el));
    });
  }

  initCustomer(el?: any) {
    return this.fb.group({
      FirstName: new UntypedFormControl(el && el.FirstName ? el.FirstName : ''),
      LastName: [el && el.LastName ? el.LastName : ''],
      Company: [el && el.Company ? el.Company : ''],
      JobFunction: [el && el.JobFunction ? el.JobFunction : ''],
      Function: [el && el.Function ? el.Function : ''],
      Email: [el && el.Email ? el.Email : '', Validators.compose([EmailValidator.validate])],
      Phone: [
        el && el.Phone ? el.Phone : '',
        [
          Validators.pattern(/^([+]?\d{1,2}[-| \s]?)?(\d{1,4}[-| ]?){1,4}?(\d{1,4}[-| ]?)\d{1,4}$/),
          Validators.minLength(10),
          maxPhoneLengthValidator(21)
        ]
      ]
    });
  }

  save(model: any) {
    this.processing = true;
    this.pluginService
      .updateAttendees(this.inspectionId, this.pointId, this.pluginId, model.attendees)
      .subscribe((res) => {
        this.processing = false;
        this.goToBack();
      });
  }

  add(data: any = null) {
    const control = <UntypedFormArray>this.editForm.controls['attendees'];
    if (Array.isArray(data)) {
      _.forEach(data, (el) => {
        control.push(this.initCustomer(el));
      });
    } else if (data) {
      control.push(this.initCustomer(data));
    } else {
      control.push(this.initCustomer());
    }
  }

  import() {
    this.loader.showSpinner();
    this.pluginService.getBobstContacts(this.inspectionId).subscribe((contacts) => {
      setTimeout(() => {
        this.loader.hideSpinner();
        this.add(contacts);
      }, 100);
    });
  }

  cancel() {
    this.goToBack();
  }

  openAttendeeDeleteConfirm(i: number) {
    this.attendeeDeleteConfirm.open();
    this.contactToRemove = i;
  }

  remove(e: any) {
    const control = <UntypedFormArray>this.editForm.controls['attendees'];
    control.removeAt(this.contactToRemove);
  }

  openFunctionSelector(i: number): void {
    this.currentItem = <UntypedFormGroup>this.formData.controls[i];
    this.openSelector(
      this.functionModal,
      this.bobstContactPluginService.getFunctions(),
      this.currentItem.controls['Function'].value
    );
  }

  selectFunctionMenu(item: any) {
    this.currentItem.controls['Function'].setValue(item.selectedIndex);
    this.currentItem.controls['Function'].markAsTouched();
  }

  onFunctionMenuClose() {
    this.currentItem?.controls['Function']?.markAsTouched();
  }

  public selectMenu(item: any) {
    switch (item) {
      case 1:
        this.openDeleteConfirm();
        break;
      case 10:
        this.gotoEditJsonPage();
        break;
      case 11:
        this.gotoEditPage();
        break;
      case 20:
        this.openImportContactsModal();
        break;
      default:
    }
  }

  openImportContactsModal() {
    this.loader.showSpinner();
    this.pluginService.getBobstContacts(this.inspectionId).subscribe((contacts) => {
      this.loader.hideSpinner();
      this.importCustomersModal.modalFooter = false;
      this.importCustomersModal.modalHeader = false;
      this.importCustomersModal.modalMessage = false;
      this.importCustomersModal.open(ContactsModalComponent, _.cloneDeep(contacts));
    });
  }
}
